export default "__VITE_ASSET__DybFCM_n__"